"use strict"
exports.__esModule = true;
exports.AdobeIconConfig = {
  name: 'AdobeIcon',
  height: 512,
  width: 512,
  svgPath: 'M315.5 64h170.9v384L315.5 64zm-119 0H25.6v384L196.5 64zM256 206.1L363.5 448h-73l-30.7-76.8h-78.7L256 206.1z',
  yOffset: 0,
  xOffset: 0,
};
exports.AdobeIcon = require('../createIcon').createIcon(exports.AdobeIconConfig);
exports["default"] = exports.AdobeIcon;